module.exports = __webpack_public_path__ + "img/cube3.7c7b61df.png";